<template>
	<div
		:class="[$style['app-spinner'], {
			[$style['app-spinner--center']]: center
		}]"
	>
		<svg
			:class="$style['app-spinner__svg']"
			:width="width"
			:height="width"
			viewBox="0 0 66 66"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				:class="$style['app-spinner__svg-path']"
				fill="none"
				stroke-width="6"
				cx="33"
				cy="33"
				r="30"
			/>
		</svg>
	</div>
</template>
<script>
export default {
	name: 'Spinner',
	props: {
		width: {
			type: String,
			default: '64px'
		},
		center: {
			type: [String, Boolean],
			default: false
		}
	}
}
</script>
<style lang="scss" module>


	$offset: 187;
	$duration: 1.4s;

	.app-spinner {
		&__svg {
			animation: rotator $duration linear infinite;
		}

		&__svg-path {
			stroke-dasharray: $offset;
			stroke-dashoffset: 0;
			transform-origin: center;
			stroke: getColor(tertiary);
			animation:
			dash $duration ease-in-out infinite;
		}

		&--center {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 300px;
		}
	}

	@keyframes rotator {
		0% { transform: rotate(0deg); }
		100% { transform: rotate(270deg); }
	}

	@keyframes dash {
		0% {
			stroke-dashoffset: $offset;
		}

		50% {
			stroke-dashoffset: calc($offset / 4);
			transform:rotate(135deg);
		}

		100% {
			stroke-dashoffset: $offset;
			transform:rotate(450deg);
		}
	}
</style>
